import profileimg from "../assets/profileimg.png";
import { FaTwitter, FaLinkedin, FaChevronCircleDown } from 'react-icons/fa'

const Home = () => {
    return (
        <section id="home" className="section-bg-b3">
            <div className="min-h-screen grid items-center">
                <div className="container w-full px-2 md:px-[30px] lg:px-16 pt-[100px]">
                    {/* Grid layout for responsive design */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center justify-center">
                        {/* Left content section */}
                        <div className="order-2 lg:order-1 text-center lg:text-left flex flex-col">
                            {/* Heading - order 1 on mobile */}
                            <div className="order-1">
                                <p className="font-bold text-small uppercase mt-[15px] lg:mt-[0px]">
                                    Hello, <span className="text-primary">My Name Is</span>
                                </p>

                                <h1 className="text-white text-[40px] sm:text-[50px] md:text-[60px] lg:text-biggest leading-[1.2] mt-[15px] [text-shadow:2px_2px_hsl(0,0%,0%),_-2px_2px_hsl(0,0%,0%),_2px_-2px_hsl(0,0%,0%),_-2px_-2px_hsl(0,0%,0%),_5px_5px_0_rgb(0_0_0_/_20%)] text-cs">
                                    <span className="text-primary">HARSHAL</span> RAJPUT
                                </h1>
                            </div>

                            {/* Description and Buttons - order 3 on mobile */}
                            <div className="order-3 lg:order-2">
                                <p className="text-large my-[30px] max-w-[520px] mx-auto lg:mx-0">
                                    I’m a Full-stack Software Developer who enjoys building reliable, scalable products and solving real-world problems through clean and thoughtful engineering. I focus on creating systems that are efficient, maintainable, and deliver meaningful user experiences.
                                </p>

                                <div className="flex items-center mt-[30px] mb-[35px] justify-center lg:justify-start">
                                    {/* Connect Button */}
                                    <a
                                        href="#contact"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const element = document.getElementById('contact');
                                            if (element) {
                                                const yOffset = -100;
                                                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                                window.scrollTo({ top: y, behavior: 'smooth' });
                                            }
                                        }}
                                        className="btn text-cs cursor-pointer relative after:content-[''] after:absolute after:top-1/2 after:-right-[32px] after:-translate-y-1/2 after:w-8 after:h-[2px] after:bg-border inline-flex items-center gap-2"
                                    >
                                        Connect <FaChevronCircleDown className="text-lg" />
                                    </a>

                                    {/* Social Icons */}
                                    <div className="flex gap-4 items-center ml-[60px] lg:ml-[60px]">
                                        <a href="https://www.linkedin.com/in/harshal-rajput-94755a228/" target="_blank" rel="noopener noreferrer" className="text-title text-[16px] transition-all duration-700 ease-custom hover:text-primary">
                                            <FaLinkedin />
                                        </a>
                                        <a href="https://twitter.com/Harshal__Rajput" target="_blank" rel="noopener noreferrer" className="text-title text-[16px] transition-all duration-700 ease-custom hover:text-primary">
                                            <FaTwitter />
                                        </a>
                                    </div>
                                </div>

                                {/* Scroll Down Button - hidden on mobile, visible on lg */}
                                <a
                                    href="#skills"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const element = document.getElementById('skills');
                                        if (element) {
                                            const yOffset = -100;
                                            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                            window.scrollTo({ top: y, behavior: 'smooth' });
                                        }
                                    }}
                                    className="hidden lg:flex items-center gap-4 text-title hover:text-primary transition-all duration-700 ease-custom group justify-center lg:justify-start mt-[60px] cursor-pointer"
                                >
                                    <div className="w-12 h-12 rounded-full border-2 border-border flex items-center justify-center group-hover:border-primary transition-all duration-700">
                                        <svg
                                            className="w-5 h-5 animate-bounce"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M19 14l-7 7m0 0l-7-7m7 7V3"
                                            />
                                        </svg>
                                    </div>
                                    <span className="text-small font-medium text-cs">Scroll Down</span>
                                </a>
                            </div>
                        </div>

                        {/* Right image section - order 2 on mobile */}
                        <div className="order-1 lg:order-2 relative flex justify-center w-full">
                            <div className="relative w-full max-w-[300px] sm:max-w-[350px] md:max-w-[400px] lg:max-w-[450px]">
                                <div
                                    className="pb-[100%] rounded-full relative mb-0 lg:mb-16"
                                    style={{
                                        background: `
                                            repeating-linear-gradient(
                                                0deg,
                                                transparent,
                                                transparent 8px,
                                                hsl(249, 100%, 63%) 8px,
                                                hsl(249, 100%, 63%) 16px
                                            ) 0% 0% / 100% 100%,
                                            linear-gradient(
                                                to bottom,
                                                transparent 0%,
                                                transparent 30%,
                                                hsl(249, 100%, 63%) 60%,
                                                hsl(249, 100%, 63%) 90%
                                            )
                                        `
                                    }}
                                >
                                    <img src={profileimg} alt="Harshal Rajput" className="absolute bottom-0 left-1/2 -translate-x-1/2 h-[170%] w-auto rounded-full object-cover" />
                                </div>

                                {/* Stat pills - visible on all screens */}
                                <p className="flex border-2 border-border bg-bg shadow px-3 sm:px-5 w-[160px] sm:w-[200px] lg:w-[250px] h-[60px] sm:h-[70px] lg:h-[82px] rounded-[82px] items-center absolute bottom-[16%] lg:bottom-[29%] -left-[5%] sm:-left-[10%] lg:-left-[15%] z-20">
                                    <span className="w-1/2 text-title font-bold text-center text-[24px] sm:text-[30px] lg:text-[37px]">
                                        5<b className="text-primary relative lg:-top-1">+</b>
                                    </span>
                                    <span className="w-1/2 text-title font-bold text-[10px] sm:text-[12px] lg:text-[13px] leading-[1.5em] text-cs">
                                        Years of<span className="text-primary"> Coding</span>
                                    </span>
                                </p>

                                <p className="flex border-2 border-border bg-bg shadow px-3 sm:px-5 w-[160px] sm:w-[200px] lg:w-[250px] h-[60px] sm:h-[70px] lg:h-[82px] rounded-[82px] items-center absolute bottom-[2%] lg:bottom-[19%] -right-[5%] sm:-right-[10%] lg:-right-[15%] z-20">
                                    <span className="w-1/2 text-title font-bold text-center text-[24px] sm:text-[30px] lg:text-[37px]">
                                        10<b className="text-primary relative lg:-top-1">+</b>
                                    </span>
                                    <span className="w-1/2 text-title font-bold text-[10px] sm:text-[12px] lg:text-[13px] leading-[1.5em] text-cs">
                                        Completed <span className="text-primary">Projects</span>
                                    </span>
                                </p>

                                {/* Introductory text below profile image - hidden on mobile, visible on lg */}
                                <p className="font-bold text-center hidden lg:block">
                                    <span className="text-cs text-small block">A <span className="text-primary">Software Enthusiast</span> engaged in <span className="text-primary">developing</span> and <span className="text-primary">trying out</span> new stuff.</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}

export default Home